/* ============================================================
   Globo Smart Filter: productlinks in de juiste taal (DEED, 06-09-2026)
   Globo rendert de productkaarten client-side met links zonder
   taalprefix (/collections/... in plaats van /en/collections/...).
   Dit script zet de prefix van de huidige taal ervoor, ook na
   filteren/pagineren (MutationObserver). Op de primaire taal (NL)
   doet het niets.
   ============================================================ */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  if (root === '/') return;
  var prefix = root.replace(/\/$/, '');

  function fixLinks(scope) {
    if (!scope || !scope.querySelectorAll) return;
    var links = scope.querySelectorAll('a[href^="/collections/"], a[href^="/products/"]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      a.setAttribute('href', prefix + a.getAttribute('href'));
    }
  }

  function run() {
    fixLinks(document);
    var observer = new MutationObserver(function (mutations) {
      for (var m = 0; m < mutations.length; m++) {
        var added = mutations[m].addedNodes;
        for (var n = 0; n < added.length; n++) {
          var node = added[n];
          if (node.nodeType !== 1) continue;
          if (node.tagName === 'A') fixLinks(node.parentNode);
          else fixLinks(node);
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
